import { DateTime } from 'luxon';
import CustomForm from '../../lib/FormValidator/Form/CustomForm';
import { Arbitro } from '../../system/Arbitro/Arbitro';
import { Partido } from '../../system/Partido/Partido';
import { PlanillaPartido } from '../../system/PlanillaPartido/PlanillaPartido';
import { PlanillaPartidoAssertions } from '../../system/PlanillaPartido/PlanillaPartidoAssertions';
import { PlanillaPartidoJugador } from '../../system/PlanillaPartidoJugador/PlanillaPartidoJugador';
import { PlanillaPartidoOficial } from '../../system/PlanillaPartidoOficial/PlanillaPartidoOficial';
import { PlanillaPartidoOficialAuxiliar } from '../../system/PlanillaPartidoOficialAuxiliar/PlanillaPartidoOficialAuxiliar';
import { PlanillaPartidoOficialMesaNoRegsitrado } from '../../system/PlanillaPartidoOficialMesaNoRegsitrado/PlanillaPartidoOficialMesaNoRegsitrado';
import { Jugador } from '../../system/Jugador/Jugador';
import { PlanillaPartidoContext } from '../../system/PlanillaPartido/PlanillaPartidoSystem';
import { Categoria } from '../../system/Categoria/Categoria';
import { PlanillaPartidoReglaJugadorDisponibleCategoriasInferior } from '../../system/PlanillaPartidoReglaJugadorDisponibleCategoriasInferior/PlanillaPartidoReglaJugadorDisponibleCategoriasInferior';
class PlanillaPartidoForm extends CustomForm {
  protected constructor(
    pp_id: string | null,
    pp_parid: number,
    pp_arbid_1: number,
    pp_arbid_2: number,
    pp_fecha_hora_inicio: Date,
    pp_cjid: number | null,
    pp_ofmid_local: number,
    pp_ofmid_visitante: number,
    pp_goles_local: number,
    pp_goles_visitante: number,
    pp_diferido: any,
    pp_observacion: any,
    pp_informe: any,
    pp_estado: string,
    pp_usid_carga: number,
    pp_fecha_carga: Date,
    pp_puede_empatar: boolean,
    pp_suspendida: boolean,
    __v: string,
    pp_url_transmision: string,

    partido: Partido | null,
    arbitro1: Arbitro | null,
    arbitro2: Arbitro | null,
    planilla_partido_jugador: PlanillaPartidoJugador[],
    oficiales: PlanillaPartidoOficial[],
    oficiales_auxiliares: PlanillaPartidoOficialAuxiliar[],
    oficiales_mesa_no_registrados: PlanillaPartidoOficialMesaNoRegsitrado[]
  ) {
    const pla = PlanillaPartidoAssertions.build();
    super('PlanillaPartido', pla);
    this.addInputAsserted('pp_id', pp_id);
    this.addInput('pp_parid', pp_parid);
    this.addInput('pp_arbid_1', pp_arbid_1);
    this.addInput('pp_arbid_2', pp_arbid_2);
    this.addInput('pp_fecha_hora_inicio', pp_fecha_hora_inicio);
    this.addInput('pp_cjid', pp_cjid);
    this.addInput('pp_ofmid_local', pp_ofmid_local);
    this.addInput('pp_ofmid_visitante', pp_ofmid_visitante);
    this.addInput('pp_goles_local', pp_goles_local);
    this.addInput('pp_goles_visitante', pp_goles_visitante);
    this.addInput('pp_diferido', pp_diferido);
    this.addInput('pp_observacion', pp_observacion);
    this.addInput('pp_informe', pp_informe);
    this.addInput('pp_estado', pp_estado);
    this.addInput('pp_usid_carga', pp_usid_carga);
    this.addInput('pp_fecha_carga', pp_fecha_carga);
    this.addInput('pp_puede_empatar', pp_puede_empatar);
    this.addInput('pp_suspendida', pp_suspendida);

    this.addInputAsserted('__v', __v);
    this.addInputAsserted('pp_url_transmision', pp_url_transmision);

    this.addInputAsserted('partido', partido);
    this.addInputAsserted('arbitro1', arbitro1);
    this.addInputAsserted('arbitro2', arbitro2);
    this.addInput('planilla_partido_jugador', planilla_partido_jugador);
    this.addInputAsserted('oficiales', oficiales);
    this.addInputAsserted('oficiales_auxiliares', oficiales_auxiliares);
    this.addInputAsserted('oficiales_mesa_no_registrados', oficiales_mesa_no_registrados);
  }

  private static build(
    pp_id: string | null,
    pp_parid: number,
    pp_arbid_1: number,
    pp_arbid_2: number,
    pp_fecha_hora_inicio: Date,
    pp_cjid: number | null,
    pp_ofmid_local: number,
    pp_ofmid_visitante: number,
    pp_goles_local: number,
    pp_goles_visitante: number,
    pp_diferido: any,
    pp_observacion: any,
    pp_informe: any,
    pp_estado: string,
    pp_usid_carga: number,
    pp_fecha_carga: Date,
    pp_puede_empatar: boolean,
    pp_suspendida: boolean,
    __v: string,
    pp_url_transmision: string,

    partido: Partido | null,
    arbitro1: Arbitro | null,
    arbitro2: Arbitro | null,
    planilla_partido_jugador: PlanillaPartidoJugador[],
    oficiales: PlanillaPartidoOficial[],
    oficiales_auxiliares: PlanillaPartidoOficialAuxiliar[],
    oficiales_mesa_no_registrados: PlanillaPartidoOficialMesaNoRegsitrado[]
  ) {
    return new this(
      pp_id,
      pp_parid,
      pp_arbid_1,
      pp_arbid_2,
      pp_fecha_hora_inicio,
      pp_cjid,
      pp_ofmid_local,
      pp_ofmid_visitante,
      pp_goles_local,
      pp_goles_visitante,
      pp_diferido,
      pp_observacion,
      pp_informe,
      pp_estado,
      pp_usid_carga,
      pp_fecha_carga,
      pp_puede_empatar,
      pp_suspendida,
      __v,
      pp_url_transmision,

      partido,
      arbitro1,
      arbitro2,
      planilla_partido_jugador,
      oficiales,
      oficiales_auxiliares,
      oficiales_mesa_no_registrados
    );
  }

  static buildFromPlanilla(planilla: PlanillaPartido, context: PlanillaPartidoContext) {
    let jugadorList: PlanillaPartidoJugador[] = [];
    let oficialList: PlanillaPartidoOficial[] = [];
    let oficialAuxiliarList: PlanillaPartidoOficialAuxiliar[] = [];

    const torneoTieneListaBuenaFe = planilla.getPartido()!.getTorneo()!.getTieneListaBuenaFe();

    if (torneoTieneListaBuenaFe) {
      jugadorList = context.jugadoresListaBuenaFeLocal
        .concat(context.jugadoresListaBuenaFeVisitante)
        .filter(
          (j) => !planilla.getPlanillaPartidoJugadorList().some((ppj) => +ppj.getJugid() === +j.getJugid())
        )
        .map((jugBuenaFe) => PlanillaPartidoJugador.createFromBuenaFe(+planilla.getId()!, jugBuenaFe, false));

      oficialList = context.oficialesListaBuenaFeLocal
        .concat(context.oficialesListaBuenaFeVisitante)
        .filter(
          (o) => !planilla.getPlanillaPartidoOficialList().some((ppoa) => +ppoa.getEntid() === +o.getEntid())
        )
        .map((ofBuenaFe) => PlanillaPartidoOficial.createFromBuenaFe(+planilla.getId()!, ofBuenaFe));

      oficialAuxiliarList = context.oficialesAuxiliaresListaBuenaFeLocal
        .concat(context.oficialesAuxiliaresListaBuenaFeVisitante)
        .filter(
          (ppoaContext) =>
            !planilla
              .getPlanillaPartidoOficialAuxiliarList()
              .some((ppoa) => +ppoa.getDni() === +ppoaContext.getDocumentoNumero())
        )
        .map((ofAuxBuenaFe) =>
          PlanillaPartidoOficialAuxiliar.createFromBuenaFe(+planilla.getId()!, ofAuxBuenaFe)
        );
    } else {
      jugadorList = context.jugadoresEquipoLocal
        .concat(context.jugadoresEquipoVisitante)
        .filter(
          (j) => !planilla.getPlanillaPartidoJugadorList().some((ppj) => +ppj.getJugid() === +j.getJugid())
        )
        .map((jxe) => PlanillaPartidoJugador.createFromJugadorXEquipo(+planilla.getId()!, jxe));
    }

    const jugadorListForPlanilla = jugadorList.concat(planilla.getPlanillaPartidoJugadorList());
    const oficialListForPlanilla = oficialList.concat(planilla.getPlanillaPartidoOficialList());
    const oficialAuxListForPlanilla = oficialAuxiliarList.concat(
      planilla.getPlanillaPartidoOficialAuxiliarList()
    );

    return new this(
      planilla.getId(),
      planilla.getParid(),
      planilla.getArbid1(),
      planilla.getArbid2(),
      planilla.getFechaHoraInicio(),
      planilla.getCjid(),
      planilla.getOfmidLocal(),
      planilla.getOfmidVisitante(),
      planilla.getGolesLocal(),
      planilla.getGolesVisitante(),
      !planilla.getDiferido(),
      planilla.getObservacion(),
      planilla.getInforme(),
      planilla.getEstado(),
      planilla.getUsidCarga(),
      planilla.getFechaCarga(),
      planilla.getPuedeEmpatar(),
      planilla.getSuspendida(),
      planilla.get__v(),
      planilla.getUrlTransmision(),

      planilla.getPartido(),
      planilla.getArbitro1(),
      planilla.getArbitro2(),
      jugadorListForPlanilla,
      oficialListForPlanilla,
      oficialAuxListForPlanilla,
      planilla.getPlanillaPartidoOficialMesaNoRegistradoList()
    );
  }

  static buildFromPartido(partido: Partido, context: PlanillaPartidoContext) {
    let jugadorList: PlanillaPartidoJugador[] = [];
    let oficialList: PlanillaPartidoOficial[] = [];
    let oficialAuxiliarList: PlanillaPartidoOficialAuxiliar[] = [];

    if (partido.getTorneo()!.getTieneListaBuenaFe()) {
      jugadorList = context.jugadoresListaBuenaFeLocal
        .concat(context.jugadoresListaBuenaFeVisitante)
        .map((jugBuenaFe) => PlanillaPartidoJugador.createFromBuenaFe(0, jugBuenaFe));

      oficialList = context.oficialesListaBuenaFeLocal
        .concat(context.oficialesListaBuenaFeVisitante)
        .map((ofBuenaFe) => PlanillaPartidoOficial.createFromBuenaFe(0, ofBuenaFe));

      oficialAuxiliarList = context.oficialesAuxiliaresListaBuenaFeLocal
        .concat(context.oficialesAuxiliaresListaBuenaFeVisitante)
        .map((ofAuxBuenaFe) => PlanillaPartidoOficialAuxiliar.createFromBuenaFe(0!, ofAuxBuenaFe));
    } else {
      jugadorList = context.jugadoresEquipoLocal
        .concat(context.jugadoresEquipoVisitante)
        .map((jxe) => PlanillaPartidoJugador.createFromJugadorXEquipo(0, jxe));
    }

    return new this(
      'new',
      partido.getId() ? +partido.getId()! : 0,
      partido.getArbid1() ? +partido.getArbid1()! : 0,
      partido.getArbid2() ? +partido.getArbid2()! : 0,
      partido.getHoraInicioInDate(),
      partido.getCjid(),
      0,
      0,
      0,
      0,
      true,
      '',
      '',
      '',
      0,
      new Date(),
      true,
      false,
      '',
      '',
      partido,
      partido.getArbitro1(),
      partido.getArbitro2(),
      jugadorList,
      oficialList,
      oficialAuxiliarList,
      []
    );
  }

  static initialize() {
    return this.build(
      null,
      0,
      0,
      0,
      new Date(),
      0,
      0,
      0,
      0,
      0,
      null,
      null,
      null,
      '',
      0,
      new Date(),
      false,
      false,
      '',
      '',
      null,
      null,
      null,
      // [],
      [],
      [],
      [],
      []
    );
  }

  static with(
    pp_id: string | null,
    pp_parid: number,
    pp_arbid_1: number,
    pp_arbid_2: number,
    pp_fecha_hora_inicio: Date,
    pp_cjid: number | null,
    pp_ofmid_local: number,
    pp_ofmid_visitante: number,
    pp_goles_local: number,
    pp_goles_visitante: number,
    pp_diferido: any,
    pp_observacion: any,
    pp_informe: any,
    pp_estado: string,
    pp_usid_carga: number,
    pp_fecha_carga: Date,
    pp_puede_empatar: boolean,
    pp_suspendida: boolean,
    __v: string,
    pp_url_transmision: string,

    partido: Partido,
    arbitro1: Arbitro,
    arbitro2: Arbitro,
    planilla_partido_jugador: PlanillaPartidoJugador[],
    oficiales: PlanillaPartidoOficial[],
    oficiales_auxiliares: PlanillaPartidoOficialAuxiliar[],
    oficiales_mesa_no_registrados: PlanillaPartidoOficialMesaNoRegsitrado[]
  ) {
    return this.build(
      pp_id,
      pp_parid,
      pp_arbid_1,
      pp_arbid_2,
      pp_fecha_hora_inicio,
      pp_cjid,
      pp_ofmid_local,
      pp_ofmid_visitante,
      pp_goles_local,
      pp_goles_visitante,
      pp_diferido,
      pp_observacion,
      pp_informe,
      pp_estado,
      pp_usid_carga,
      pp_fecha_carga,
      pp_puede_empatar,
      pp_suspendida,
      __v,
      pp_url_transmision,
      partido,
      arbitro1,
      arbitro2,
      planilla_partido_jugador,
      oficiales,
      oficiales_auxiliares,
      oficiales_mesa_no_registrados
    );
  }

  validateRulesInAddForTeam(
    equipoId: string,
    reglas: PlanillaPartidoReglaJugadorDisponibleCategoriasInferior[],
    categorias: Categoria[],
    jugador: Jugador
  ) {
    const categoriaJugador = categorias.find(
      (c) =>
        (+c.getAnioDesde() <= jugador.getClase() || !c.getAnioDesde()) &&
        (+c.getAnioHasta() >= jugador.getClase() || !c.getAnioHasta())
    );
    const reglaAplicable = reglas.find((r) => +r.getCatinfid() === +categoriaJugador!.getId()!);

    let cantJugadores = 0;
    if (reglaAplicable) {
      const jugadores = this.getJugadoresByEquipo(equipoId);
      jugadores.forEach((j) => {
        const catJug = categorias.find(
          (c) =>
            (+c.getAnioDesde() <= j.getClase() || !c.getAnioDesde()) &&
            (+c.getAnioHasta() >= j.getClase() || !c.getAnioHasta())
        );

        if (
          +reglaAplicable.getCatinfid() === +catJug!.getId()! &&
          this.getDorsalBy(j.getId()!) &&
          +j.getId()! !== +jugador.getId()!
        ) {
          cantJugadores++;
        }
      });

      if (cantJugadores + 1 > +reglaAplicable.getCantPermitida()) {
        return false;
      } else {
        return true;
      }
    }
    return true;
  }

  getIdInput() {
    return this.getInputByName('pp_id');
  }

  getParidInput() {
    return this.getInputByName('pp_parid');
  }

  getArbid1Input() {
    return this.getInputByName('pp_arbid_1');
  }

  getArbid2Input() {
    return this.getInputByName('pp_arbid_2');
  }

  getFechaHoraInicioInput() {
    return this.getInputByName('pp_fecha_hora_inicio');
  }

  getCjidInput() {
    return this.getInputByName('pp_cjid');
  }

  getOfmidLocalInput() {
    return this.getInputByName('pp_ofmid_local');
  }

  getOfmidVisitanteInput() {
    return this.getInputByName('pp_ofmid_visitante');
  }

  getGolesLocalInput() {
    return this.getInputByName('pp_goles_local');
  }
  getUrlTransmisionInput() {
    return this.getInputByName('pp_url_transmision');
  }

  get__vInput() {
    return this.getInputByName('__v');
  }

  getGolesVisitanteInput() {
    return this.getInputByName('pp_goles_visitante');
  }

  getDiferidoInput() {
    return this.getInputByName('pp_diferido');
  }

  getObservacionInput() {
    return this.getInputByName('pp_observacion');
  }

  getInformeInput() {
    return this.getInputByName('pp_informe');
  }

  getEstadoInput() {
    return this.getInputByName('pp_estado');
  }

  getUsidCargaInput() {
    return this.getInputByName('pp_usid_carga');
  }

  getFechaCargaInput() {
    return this.getInputByName('pp_fecha_carga');
  }

  getPuedeEmpatarInput() {
    return this.getInputByName('pp_puede_empatar');
  }

  getSuspendidaInput() {
    return this.getInputByName('pp_suspendida');
  }

  getPartidoInput() {
    return this.getInputByName('partido');
  }

  getArbitro1Input() {
    return this.getInputByName('arbitro1');
  }

  getArbitro2Input() {
    return this.getInputByName('arbitro2');
  }

  getPlanillaPartidoJugadoresInput() {
    return this.getInputByName('planilla_partido_jugador');
  }

  getOficialesInput() {
    return this.getInputByName('oficiales');
  }

  getOficialesAuxiliaresInput() {
    return this.getInputByName('oficiales_auxiliares');
  }

  getOficialesMesaNoRegistradosInput() {
    return this.getInputByName('oficiales_mesa_no_registrados');
  }

  getOficialNoRegistradoByEquipoId(equipoId: string) {
    const oficialesNoRegistrados =
      this.getOficialesMesaNoRegistradosInput().getValue() as PlanillaPartidoOficialMesaNoRegsitrado[];
    const ret = oficialesNoRegistrados.find((onr) => +onr.getEqid() === +equipoId && onr.isActive());
    return ret;
  }

  getHorario() {
    const date = this.getFechaHoraInicioInput().getValue() as Date;
    return DateTime.fromJSDate(date).toFormat('HH:mm');
  }

  getJugadoresByEquipo(equipoId: string) {
    return this.getListPlanillaPartidoJugadoresByEquipo(equipoId).map((ppj) => ppj.getJugador());
  }

  getDorsalBy(jugId: string) {
    const planillaPartidoJugador =
      this.getPlanillaPartidoJugadoresInput().getValue() as PlanillaPartidoJugador[];
    const jug = planillaPartidoJugador.find((ppj) => +ppj.getJugid() === +jugId && ppj.isActive());
    return jug?.getDorsal() ? String(jug?.getDorsal()) : '';
  }

  getListJugadoresByEquipo(equipoId: string, listContext: Jugador[]) {
    const jugEnEquipo = this.getJugadoresByEquipo(equipoId);

    const _list = listContext.filter((j) => {
      let existe = false;
      jugEnEquipo.forEach((je) => {
        if (j.isIdentifiedAs(je)) {
          existe = true;
        }
      });
      let ret = !existe;
      return ret;
    });
    return _list.sort((a, b) => Jugador.sortByFullameFn(a, b));
  }

  getListPlanillaPartidoJugadoresByEquipo(equipoId: string) {
    const planillaPartidoJugador =
      this.getPlanillaPartidoJugadoresInput().getValue() as PlanillaPartidoJugador[];

    return planillaPartidoJugador
      .filter((ppj) => +ppj.getEqid()! === +equipoId && ppj.isActive())
      .sort((a, b) => Jugador.sortByFullameFn(a.getJugador(), b.getJugador()));
  }

  getOficialesAuxiliaresByEquipoId(equipoId: string) {
    const ret = this.getOficialesAuxiliaresInput()
      .getValue()
      .filter((oa: PlanillaPartidoOficialAuxiliar) => oa.isActive() && +oa.getEqid() === +equipoId)
      .map((oa: PlanillaPartidoOficialAuxiliar) => oa.toJSON());
    return ret;
  }

  toPlanillaPartido(): PlanillaPartido {
    return PlanillaPartido.createFrom(
      this.getIdInput().getValue(),
      this.getParidInput().getValue(),
      this.getArbid1Input().getValue(),
      this.getArbid2Input().getValue() ? this.getArbid2Input().getValue() : null,
      this.getFechaHoraInicioInput().getValue(),
      this.getCjidInput().getValue(),
      this.getOfmidLocalInput().getValue() ? this.getOfmidLocalInput().getValue() : null,
      this.getOfmidVisitanteInput().getValue() ? this.getOfmidVisitanteInput().getValue() : null,
      this.getGolesLocalInput().getValue(),
      this.getGolesVisitanteInput().getValue(),
      !this.getDiferidoInput().getValue(), // lo niego pq en el formulario se pregunta si esta en vivo
      this.getObservacionInput().getValue(),
      this.getInformeInput().getValue(),
      this.getEstadoInput().getValue(),
      this.getUsidCargaInput().getValue(),
      this.getFechaCargaInput().getValue(),
      this.getPuedeEmpatarInput().getValue(),
      this.getSuspendidaInput().getValue(),
      this.get__vInput().getValue(),
      this.getUrlTransmisionInput().getValue(),

      this.getPartidoInput().getValue(),
      this.getArbitro1Input().getValue(),
      this.getArbitro2Input().getValue(),
      this.getPlanillaPartidoJugadoresInput()
        .getValue()
        .filter((jpp: PlanillaPartidoJugador) => !!jpp.getDorsal()),
      this.getOficialesInput().getValue(),
      this.getOficialesAuxiliaresInput().getValue(),
      this.getOficialesMesaNoRegistradosInput().getValue()
    );
  }
}

export default PlanillaPartidoForm;
